(function ($, Drupal, once) {
  Drupal.behaviors.countrySelector = {
    attach: function (context) {
      once('countrySelector', '#country_selector', context).forEach(el => {
        $('#country_selector .dropdown-head').on('click', function () {
          $(this).parent().toggleClass('opened');
          $(this).find('.arrow').toggleClass('rotated');
        });
      });
    }
  };
})(jQuery, Drupal, once);
